import { EmbeddedBlockVariant } from '@tinct/core-api-models';
import { type BlockVariantRendering } from './types';

/**
 * Default renderer: replaces the target element's innerHTML with the variant's
 * `value`. Used for every block type without a dedicated renderer, and as the
 * fallback when a dedicated renderer opts out (returns `null`).
 *
 * Returns `null` when there's no value to inject, so the variant is skipped.
 */
export function renderDefault(
  variant: EmbeddedBlockVariant
): BlockVariantRendering | null {
  if (!variant.value) return null;
  return { kind: 'html', html: variant.value };
}
